import { all } from "redux-saga/effects";
import busySaga from "./busy/saga";
import commonSaga from "./common/saga";
import errorSaga from "./error/saga";
import pollSaga from "./poll/saga";
import userSaga from "./user/saga";
import usersSaga from "./users/saga";
import servicesSaga from "./services/saga";
import modelsSaga from "./models/saga";
import commentsSaga from "./comments/saga";
import samplesSaga from "./samples/saga";

export default function* rootSaga() {
  yield all([
    userSaga(),
    usersSaga(),
    busySaga(),
    errorSaga(),
    pollSaga(),
    commonSaga(),
    servicesSaga(),
    modelsSaga(),
    commentsSaga(),
    samplesSaga(),
  ]);
}
